import { useIonViewWillEnter } from "@ionic/react";
import LoginOTPInterfaceStore from "../../interface/LoginOTPInterface";

const useConstructor = () => {
  useIonViewWillEnter(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const userId = searchParams.get("userId");
    const verificationType = searchParams.get("verificationType");
    const { setUrlParams } = LoginOTPInterfaceStore.getState();
    setUrlParams(userId, verificationType);
  });
};

export default useConstructor;
